module.exports = __webpack_public_path__ + "static/media/roadOffset.055a3689.svg";